import Model3d from "../arrangement3d/Model3d";
import ConvexPlate3d from "../arrangement3d/ConvexPlate3d";
import Scenes from "oc-threejs/Scenes";
import Commons from "oc-commons/Commons";
import Jaco from "./Jaco";

export default class Model extends Jaco {

    isModel = true;

    /** @type {string} */
    key = null;

    // hier kommen die Vorgaben rein, die in  clippingParameters kopiert werden (achtung, nicht referenz gleich setzen!)
    /** @type {?Object} */
    defaultClippingParameters = null

    // clippingParameters werden aufgrund der generischen Natur nicht automatisch persistiert - hierzu Model ableiten
    /** @type {?Object} */
    clippingParameters = Commons.cloneDeep(this.defaultClippingParameters);
    clippingFunction = Scenes.intersect;

    materialMap = null; // ermöglicht den Austausch von Materialien

    clipping = true; // darüber kann clipping für debugzwecke ausgeschaltet werden

    /** */
    constructor(parent, key) {
        super(parent);
        this.key = key;
    }

    /** */
    toJSON() {
        const json = super.toJSON();
        json.modelKey = this.key;
        return json;
    }

    /** */
    fromJSON(json) {
        super.fromJSON(json);
        this.key = json.modelKey;
        return this;
    }

    /** */
    update3d() {
        super.update3d();
    }

    createJaco3d() {
        return new Model3d(this);
    }

    /** */
    getBoxUnclipped() {
        const model = this.getMeta();
        if (model==null) {
            debugger;
            this.getMeta();
        }
        return APP.modelsHelper.getBoundingBox(model);
    }


    /** */
    getSizeUnclipped() {
        return this.getBoxUnclipped().getSize();
    }

    /** */
    getBox() {
        const box = this.getBoxUnclipped();
        const clippingGeometry = this.getClippingGeometry();
        if (!clippingGeometry || !this.clipping) {
            return box;
        }
        clippingGeometry.computeBoundingBox();
        return box.intersect(clippingGeometry.boundingBox);
    }

    getMeta() {
        return APP.richMetadata.findModel(this.key);
    }

    /**
     * clippingGeometry muß abgeleitet werden, wenn das Object3D zugeschnitten werden soll
     * @returns {?THREE.Geometry}
     */
    getClippingGeometry() {
    }

    /** */
    get hasClippingParameters() {
        return (this.clippingParameters != null && !Commons.isEqualEpsilon(this.defaultClippingParameters, this.clippingParameters));
    }

    /** */
    get isClipped() {
        return this.clipping && this.hasClippingParameters;
    }

}
